// extracted by mini-css-extract-plugin
export default {"pageWrap":"Tc-z","fullWidth":"Uc-z","heading":"Vc-z","fullBleed":"Wc-z","hidden":"Xc-z"};